import { connectMenu } from 'instantsearch.js/es/connectors';

const changeHandler = (event) => {
    const value = event.target.parentNode.querySelector('.js-search-form-select-value');
    value.textContent = event.target.value;
};

// create the render function
const renderMenuSelect = (renderOptions, isFirstRender) => {
    const {
        items,
        canRefine,
        refine,
        widgetParams,
    } = renderOptions;

    if (isFirstRender) {
        const select = document.createElement('select');
        select.classList.add(
            'absolute',
            'top-0',
            'right-0',
            'bottom-0',
            'left-0',
            '-z-10',
            '!h-auto',
            'border-0',
            'bg-white',
            'group-hover/select:bg-grey-light',
        );
        select.setAttribute('name', widgetParams.attribute);

        select.addEventListener('change', (event) => {
            refine(event.target.value);
        });

        // TODO: https://developer.mozilla.org/en-US/docs/Web/API/Element/prepend
        widgetParams.container.prepend(select);
    }

    const select = widgetParams.container.querySelector('select');

    select.disabled = !canRefine;

    select.innerHTML = `
        <option value="-">${widgetParams.allLabel !== undefined ? widgetParams.allLabel : '-'}</option>
        ${items
        .map((item) => `
            <option
                value="${item.value}"
                ${item.isRefined ? 'selected' : ''}
            >
                ${item.label}
            </option>
        `).join('')}
    `;

    const value = widgetParams.container.querySelector('.js-search-form-select-value');
    value.textContent = select.value && select.value !== '' ? select.value : '-';

    select.addEventListener('change', changeHandler);
};

// create the custom widget
const customMenuSelect = connectMenu(renderMenuSelect);

export default customMenuSelect;
